function isNativeInputDateSupported() {
  const input = document.createElement("input")

  try {
    if (!Object.isFrozen(input)) {
      input.type = "date"
    }

    return input.type === "date"
  } catch (e) {
    return false
  }
}

export default isNativeInputDateSupported
